export const professionalCs = {
  'admin.workspace.intro': 'Vyberte svou pracovní oblast. Nabídka odpovídá vašim aktuálním oprávněním v organizaci.',
  'admin.workspace.empty': 'Nemáte přístup k žádné z těchto pracovních oblastí. Ověřte přidělená oprávnění se správcem organizace.',
  'admin.workspace.eventTypes': 'Nastavte typy akcí. Před vytvořením první akce musí organizace mít alespoň jeden typ.',
  'admin.workspace.members': 'Zobrazte členy organizace a jejich přidělené role. Změny vyžadují oprávnění ke správě členů.',
  'admin.workspace.privacy': 'Prohlédněte pravidla zpracování údajů a zaznamenaná rozhodnutí. Schvalování má samostatná oprávnění.',
  'admin.workspace.branding': 'Vyberte šablonu, barvy a logo. Návrh nejprve uložte a potom výslovně použijte.',
  'admin.workspace.notifications': 'Zkontrolujte stav odesílání a dostupné možnosti doručení oznámení.',
  'admin.events.form.typesLoading': 'Načítáme dostupné typy akcí…',
  'admin.events.form.typesError': 'Typy akcí se nepodařilo načíst. Obnovte seznam; rozepsané údaje zůstanou zachované.',
  'admin.events.form.chooseType': 'Vyberte typ akce',
  'attendee.enrollments.loadError': 'Registrace se nepodařilo načíst. Zkuste to znovu.',
  'attendee.enrollments.cancelError': 'Zrušení registrace se nepodařilo potvrdit. Načtěte aktuální stav a případně zkuste zrušení znovu.',
  'preview.title': 'Náhled obsahu',
  'preview.notice': 'Pouze náhled uloženého obsahu akce a programu. Nejde o přihlášení jako účastník: nezobrazuje osobní úkoly, podmínky registrace ani QR a nic nemění. Chybějící překlad může být nahrazen dostupným jazykem.',
  'admin.events.title': 'Události',
  'admin.workspace.events': 'Všechny dostupné akce včetně proběhlých. Stav akce není kontrola připravenosti programu.',
  'catalogue.readOnly': 'Akce můžete prohlížet. Nemáte oprávnění k jejich vytvoření ani úpravě.',
  'catalogue.search': 'Hledat název, kód nebo místo',
  'catalogue.allStates': 'Všechny stavy',
  'catalogue.reset': 'Zrušit filtry',
  'catalogue.count': 'Zobrazeno {shown} z {total}',
  'catalogue.noMatches': 'Tomuto filtru neodpovídá žádná akce.',
  'catalogue.table': 'Posuvný seznam událostí',
  'catalogue.eventTitle': 'Název akce',
  'catalogue.action': 'Otevřít',
  'program.chooseReadOnly': 'Vyberte bod programu pro zobrazení podrobností.',
  'program.noDescription': 'Podrobný popis zatím není uveden.',
  'program.emptyReadOnly': 'Program neobsahuje žádné body. Doplnit jej může uživatel s oprávněním k úpravě.',
  'reporting.matrix.scrollable': 'Posuvná tabulka účastníků',
  'event.viewDetail': 'Zobrazit detail',
  'program.language': 'Jazyk obsahu',
  'program.contractError': 'Server neposkytl revizi bodu. Obnovte stránku; bezpečné uložení nyní není možné.',
  'program.missingEnDescription': 'Chybí anglický popis',
  'qr.renderError': 'QR kód se nepodařilo vykreslit. Zkuste vykreslení znovu; nový kód nebude vydán.',
  'event.status': 'Stav',
  'program.description': 'Podrobnosti bodu',
  'program.title': 'Program', 'program.add': 'Přidat bod', 'program.edit': 'Upravit bod',
  'program.empty': 'Program zatím není připravený.', 'program.choose': 'Vyberte bod programu nebo přidejte nový.',
  'program.titleCs': 'Název CS', 'program.titleEn': 'Název EN',
  'program.descriptionCs': 'Popis CS', 'program.descriptionEn': 'Popis EN',
  'program.saved': 'Bod programu byl uložen.', 'program.missingTime': 'Chybí začátek nebo konec',
  'program.overlap': 'Časový překryv', 'program.missingEn': 'Chybí anglický název',
  'program.readiness': 'Kontrola programu', 'program.reviewCount': 'Počet bodů k ověření: {count}',
  'program.ready': 'Bez zjištěných upozornění',
  'program.readinessHint': 'Kontrola úplnosti nemění stav akce ani neblokuje zveřejnění.',
  'program.readOnly': 'Program můžete prohlížet. Nemáte oprávnění k úpravě.',
  'program.published': 'Akce je zveřejněná. Uložené úpravy programu se projeví účastníkům.',
  'program.unsaved': 'Máte neuložené změny. Opravdu je chcete zahodit?',
  'program.keepEditing': 'Pokračovat v úpravách',
  'attendee.registrationOptions': 'Další možnosti registrace',
  'program.discard': 'Zahodit změny',
  'program.invalidRange': 'Konec nesmí předcházet začátku.',
  'program.requiredTitle': 'Vyplňte český název.',
  'program.conflict': 'Bod mezitím změnil jiný uživatel. Obnovte program; vaše rozepsané údaje zůstaly zachované.',
  'program.reload': 'Obnovit program',
  'event.settings': 'Nastavení', 'event.participants': 'Účastníci',
  'event.transitionConfirm': 'Změnit stav akce na „{state}“?',
  'home.next': 'Moje nejbližší akce', 'home.noNext': 'Nemáte žádnou aktuální registraci na nadcházející akci.',
  'home.registrations': 'Všechny moje registrace', 'home.detail': 'Detail a vstupní QR',
  'home.tasks': 'Moje úkoly', 'home.hello': 'Dobrý den, {name}',
  'qr.rotation': 'Průkaz zůstává stejný při opětovném zobrazení. Platí pro tento běh, dokud nevyprší nebo nebude zneplatněn. Načtení vyžaduje připojení.',
  'qr.noExpiry': 'Server neuvádí čas expirace. To není záruka trvalé ani offline platnosti.',
  'qr.close': 'Skrýt QR kód',
  'time.invalid': 'Tento místní čas není platný. Zkontrolujte datum a přechod na letní čas.',
  'time.ambiguous': 'Tento místní čas se při změně zimního času opakuje. Zvolte jednoznačný čas.',
  'time.zone': 'Zadejte platné časové pásmo.',
  'scanner.storageError': 'Frontu nelze bezpečně uložit v tomto prohlížeči. Záznam není potvrzen; nepokračujte offline.',
  'scanner.captured': 'QR byl načten. Zkontrolujte akci a potvrďte příchod nebo odchod.',
  'scanner.arrival': 'Příchod', 'scanner.departure': 'Odchod',
  'scanner.pendingNotice': 'Uloženo ve frontě; docházka ještě není potvrzena serverem.',
  'scanner.legacyNotice': 'V prohlížeči je starší fronta bez vlastníka. Automaticky se neodesílá; kontaktujte správce.',
  'home.tasksFor': 'Úkoly pro akci: {event}',
  'home.noTask': 'Pro tuto registraci není žádný další neuzavřený úkol. Ostatní registrace najdete v seznamu úkolů.',
  'home.taskDeadline': 'Termín',
  'home.starts': 'Začátek',
  'home.allTasks': 'Všechny moje úkoly',
  'scanner.queue.waitingCount': 'Čeká na server: {count}',
  'scanner.queue.failedCount': 'Chyby: {count}',
  'scanner.queue.confirmationHint': 'Za potvrzené se považují pouze záznamy přijaté serverem. Čekající a chybové záznamy zůstávají ve frontě.',
  'reporting.intro': 'Přihlášky, docházka a úkoly jednotlivých účastníků.',
  'reporting.provisional': 'Výsledek odpovídá dostupným datům a nastaveným pravidlům. Není finálním HR rozhodnutím.',
  'reporting.summary.title': 'Souhrn stavů',
  'reporting.summary.completion': 'Vyhodnocení',
  'reporting.column.completion': 'Vyhodnocení',
  'reporting.filters.search': 'Hledat účastníka nebo e-mail',
  'reporting.filters.reviewOnly': 'Pouze stavy k ověření',
  'reporting.filters.reviewHint': 'Filtr používá upozornění, blokované, částečné a neznámé stavy vrácené serverem. Nemění hodnocení.',
  'reporting.filters.count': 'Zobrazeno {shown} z {total}',
  'reporting.filters.empty': 'Tomuto filtru neodpovídá žádný účastník.',
  'reporting.filters.reset': 'Zrušit filtry',
  'reporting.filters.exportAll': 'CSV a PDF obsahují celý report, nikoli pouze vyfiltrované řádky.',
  'reporting.status.details': 'Vysvětlení stavu',
  'reporting.edocation.technicalDetails': 'Technické podrobnosti integrace',
  'reporting.edocation.intro': 'Připravte podklady pro předání docházky. Skutečné doručení závisí na režimu integrace uvedeném níže.',
};

export const professionalEn: Record<keyof typeof professionalCs, string> = {
  'admin.workspace.intro': 'Choose your workspace. The available areas reflect your current permissions in this organization.',
  'admin.workspace.empty': 'You do not have access to any of these workspaces. Check your assigned permissions with an organization administrator.',
  'admin.workspace.eventTypes': 'Configure event types. Your organization needs at least one type before creating its first event.',
  'admin.workspace.members': 'View organization members and their assigned roles. Changes require member management permission.',
  'admin.workspace.privacy': 'View data processing rules and recorded decisions. Approval requires separate permissions.',
  'admin.workspace.branding': 'Choose a template, colors and logo. Save the draft first, then explicitly apply it.',
  'admin.workspace.notifications': 'Check sending status and the available notification delivery options.',
  'admin.events.form.typesLoading': 'Loading available event types…',
  'admin.events.form.typesError': 'Event types could not be loaded. Reload the list; your draft will be preserved.',
  'admin.events.form.chooseType': 'Choose an event type',
  'attendee.enrollments.loadError': 'Your enrollments could not be loaded. Try again.',
  'attendee.enrollments.cancelError': 'Cancellation could not be confirmed. Reload the current state and, if needed, try cancelling again.',
  'preview.title': 'Content preview',
  'preview.notice': 'Preview of saved event and programme content only. This is not attendee impersonation: it shows no personal tasks, registration eligibility or QR and changes nothing. Missing translations may fall back to an available language.',
  'admin.events.title': 'Events',
  'admin.workspace.events': 'All available events, including past events. Lifecycle status is separate from programme readiness.',
  'catalogue.readOnly': 'You can view events but do not have permission to create or edit them.',
  'catalogue.search': 'Find a title, code or location',
  'catalogue.allStates': 'All statuses',
  'catalogue.reset': 'Clear filters',
  'catalogue.count': 'Showing {shown} of {total}',
  'catalogue.noMatches': 'No events match this filter.',
  'catalogue.table': 'Scrollable event list',
  'catalogue.eventTitle': 'Event title',
  'catalogue.action': 'Open',
  'program.chooseReadOnly': 'Select a programme item to view its details.',
  'program.noDescription': 'No detailed description has been provided yet.',
  'program.emptyReadOnly': 'The programme has no items. A user with editing permission can add them.',
  'reporting.matrix.scrollable': 'Scrollable participant table',
  'event.viewDetail': 'View details',
  'program.language': 'Content language',
  'program.contractError': 'The server did not return the item revision. Reload the page; a safe save is not possible now.',
  'program.missingEnDescription': 'English description missing',
  'qr.renderError': 'The QR code could not be rendered. Retry rendering; no new code will be issued.',
  'event.status': 'Status',
  'program.description': 'Item details',
  'program.title': 'Programme', 'program.add': 'Add item', 'program.edit': 'Edit item',
  'program.empty': 'The programme is not ready yet.', 'program.choose': 'Select an item or add a new one.',
  'program.titleCs': 'Title CS', 'program.titleEn': 'Title EN',
  'program.descriptionCs': 'Description CS', 'program.descriptionEn': 'Description EN',
  'program.saved': 'Programme item saved.', 'program.missingTime': 'Start or end time missing',
  'program.overlap': 'Time overlap', 'program.missingEn': 'English title missing',
  'program.readiness': 'Programme review', 'program.reviewCount': '{count} items to review',
  'program.ready': 'No warnings found',
  'program.readinessHint': 'The completeness check does not change the event status or block publishing.',
  'program.readOnly': 'You can view the programme but do not have permission to edit it.',
  'program.published': 'This event is published. Saved programme changes will be visible to attendees.',
  'program.unsaved': 'You have unsaved changes. Discard them?',
  'program.keepEditing': 'Keep editing',
  'attendee.registrationOptions': 'Registration options',
  'program.discard': 'Discard changes',
  'program.invalidRange': 'The end cannot precede the start.', 'program.requiredTitle': 'Enter the Czech title.',
  'program.conflict': 'Another user changed this item. Reload the programme; your draft has been preserved.',
  'program.reload': 'Reload programme',
  'event.settings': 'Settings', 'event.participants': 'Participants',
  'event.transitionConfirm': 'Change the event state to “{state}”?',
  'home.next': 'My next event', 'home.noNext': 'You have no active registration for an upcoming event.',
  'home.registrations': 'All my registrations', 'home.detail': 'Details and entry QR',
  'home.tasks': 'My tasks', 'home.hello': 'Hello, {name}',
  'qr.rotation': 'Displaying again keeps the same pass. It is valid for this run until it expires or is revoked. Loading requires a connection.',
  'qr.noExpiry': 'The server does not specify an expiry time. This does not guarantee permanent or offline validity.',
  'qr.close': 'Hide QR code',
  'time.invalid': 'This local time is invalid. Check the date and daylight saving transition.',
  'time.ambiguous': 'This local time repeats at the winter time transition. Choose an unambiguous time.',
  'time.zone': 'Enter a valid time zone.',
  'scanner.storageError': 'The queue cannot be safely stored in this browser. The record is not confirmed; do not continue offline.',
  'scanner.captured': 'QR captured. Check the event and confirm arrival or departure.',
  'scanner.arrival': 'Arrival', 'scanner.departure': 'Departure',
  'scanner.pendingNotice': 'Saved in the queue; attendance has not yet been confirmed by the server.',
  'scanner.legacyNotice': 'This browser has an older queue without an owner. It is not sent automatically; contact an administrator.',
  'home.tasksFor': 'Tasks for event: {event}',
  'home.noTask': 'This registration has no further unresolved tasks. Find other registrations in the task list.',
  'home.taskDeadline': 'Deadline',
  'home.starts': 'Starts',
  'home.allTasks': 'All my tasks',
  'scanner.queue.waitingCount': 'Waiting for server: {count}',
  'scanner.queue.failedCount': 'Errors: {count}',
  'scanner.queue.confirmationHint': 'Only records accepted by the server are confirmed. Pending and failed records remain in the queue.',
  'reporting.intro': 'Registrations, attendance and tasks for each participant.',
  'reporting.provisional': 'The result reflects available data and configured rules. It is not a final HR decision.',
  'reporting.summary.title': 'Status summary',
  'reporting.summary.completion': 'Evaluation',
  'reporting.column.completion': 'Evaluation',
  'reporting.filters.search': 'Find a participant or email',
  'reporting.filters.reviewOnly': 'Only statuses to review',
  'reporting.filters.reviewHint': 'This filter uses attention, blocked, partial and unknown statuses returned by the server. It does not change the evaluation.',
  'reporting.filters.count': 'Showing {shown} of {total}',
  'reporting.filters.empty': 'No participants match this filter.',
  'reporting.filters.reset': 'Clear filters',
  'reporting.filters.exportAll': 'CSV and PDF contain the full report, not just the filtered rows.',
  'reporting.status.details': 'Status explanation',
  'reporting.edocation.technicalDetails': 'Integration technical details',
  'reporting.edocation.intro': 'Prepare attendance handoff data. Actual delivery depends on the integration mode shown below.',
};
